import { CommitmentsPeriodsService_lifePeriodsVersionServiceGetPremiumHolidayPeriods } from '@festina/life-general-types/life/hooks/CommitmentsPeriodsService_lifePeriodsVersionServiceGetPremiumHolidayPeriods'

export const useFetchPremiumHolidayPeriods =
  CommitmentsPeriodsService_lifePeriodsVersionServiceGetPremiumHolidayPeriods.useSuspenseQuery
